module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-Light.610e1879.ttf";